import { render, staticRenderFns } from "./BusinessAnnualReturnsEscalations.vue?vue&type=template&id=0ebedf94&scoped=true&"
import script from "./BusinessAnnualReturnsEscalations.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsEscalations.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnsEscalations.vue?vue&type=style&index=0&id=0ebedf94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebedf94",
  null
  
)

export default component.exports